import api from './api';

class AccessControlService {
  // Permission Groups
  async getPermissionGroups() {
    const response = await api.get('/management/permission-groups/');
    return response.data.results || response.data;
  }

  async getPermissionGroupsByModule() {
    const response = await api.get('/management/permission-groups/by_module/');
    return response.data;
  }

  async createPermissionGroup(data) {
    const response = await api.post('/management/permission-groups/', data);
    return response.data;
  }

  async updatePermissionGroup(id, data) {
    const response = await api.put(`/management/permission-groups/${id}/`, data);
    return response.data;
  }

  async deletePermissionGroup(id) {
    await api.delete(`/management/permission-groups/${id}/`);
  }

  // Access Policies
  async getAccessPolicies() {
    const response = await api.get('/management/access-policies/');
    return response.data.results || response.data;
  }

  async getAccessPoliciesByResource(resourceType) {
    const response = await api.get('/management/access-policies/by_resource/', {
      params: { type: resourceType }
    });
    return response.data;
  }

  async getAccessPolicyStats() {
    const response = await api.get('/management/access-policies/stats/');
    return response.data;
  }

  async createAccessPolicy(data) {
    const response = await api.post('/management/access-policies/', data);
    return response.data;
  }

  async updateAccessPolicy(id, data) {
    const response = await api.put(`/management/access-policies/${id}/`, data);
    return response.data;
  }

  async deleteAccessPolicy(id) {
    await api.delete(`/management/access-policies/${id}/`);
  }

  // Audit Logs
  async getAuditLogs() {
    const response = await api.get('/management/audit-logs/');
    return response.data.results || response.data;
  }

  async getRecentAuditLogs(limit = 50) {
    const response = await api.get('/management/audit-logs/recent/', {
      params: { limit }
    });
    return response.data;
  }

  async getAuditLogsByUser(userId) {
    const response = await api.get('/management/audit-logs/by_user/', {
      params: { user_id: userId }
    });
    return response.data;
  }

  async getAuditLogStats() {
    const response = await api.get('/management/audit-logs/stats/');
    return response.data;
  }

  // Roles (from management service for reference)
  async getRoles() {
    const response = await api.get('/management/roles/');
    return response.data.results || response.data;
  }
}

export default new AccessControlService();
